<template>
    <div class="checkout_product_row-container">
        <div class="checkout_product_row">
            <ListOrderItem
                v-for="(listItem, index) in listItems"
                :key="listItem.list_item_id"
                v-model:listItem="listItems[index]"
                @openItemDeleteModal="openItemDeleteModal($event)"
                :readonly="props.readonly"
                :is-restricted="isRestricted(listItem)"
            />
            <ListOrderItem
                v-for="(couponItem, index) in couponItems"
                :key="index"
                class="free-item"
                v-model:listItem="couponItems[index]"
                readonly="true"
                :free-item="true"
            />
        </div>
        <div class="checkout_product_row-show_more" v-if="listItems.length > 3">
            <input v-model="showingMoreItems" id="show_more_checkout_products" class="checkout_product_row-show_more-input" type="checkbox" aria-label="Show more checkout products" />
            <div class="checkout_product_row-line"></div>
            <label @click="toggleShowingMoreItems()" for="show_more_checkout_products">
                <a>Show {{ showingMoreItems ? 'Less Items' : `All ${listItems.length } Items` }}</a>
            </label>
            <div class="checkout_product_row-line"></div>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import { ref, computed, defineEmits } from "vue";
    import ListOrderItem from "./cart/ListOrderItem.vue";
    import ListDeleteForm from "@/components/ListDeleteForm.vue";
    import { useDialog } from "primevue/usedialog";
    import { useCheckoutD2CStore } from '@/store/checkoutD2CStore';   

    let listItems = defineModel("listItems", {
        type: Array<Object>,
        default: []
    });

    let props = defineProps({
        currentList: {
            type: Object,
            default() {
                return {};
            }
        },
        restrictedItems: {
            type: Array<Object>,
            default: []
        },
        couponItems: {
            type: Array<Object>,
            default: []
        },
        readonly: {
            type: Boolean,
            default: false
        },
    });

    let dialog = useDialog(); 

    const {
        recalculateTax, getShippingRates, reloadOrderInfo, reapplyCoupon
    } = useCheckoutD2CStore();

    let deleteOpen = ref(false);
    let currentType = ref("item");
    let currentLID = ref();
    const showingMoreItems = ref(false);
    const toggleShowingMoreItems = ()=>(showingMoreItems.value = !showingMoreItems.value);

    let openItemDeleteModal = function ($event: Event) {
        const listItem = $event.value;
        currentLID.value = listItem.list_item_id;
        deleteOpen.value = true;
        dialog.open(ListDeleteForm, {
            props: {
                modal: true,
                header: "Delete List Item",
            },
            data: {
                list_id: props.currentList.list_id,
                list_item_id: listItem.list_item_id,
                type: currentType.value,
                after_delete:afterDelete,
                beforeCloseForItem: beforeCloseForItemFunc
            }
        })
    };

    const isRestricted = (listItem) => {
        return props.restrictedItems.some(
            restrictedItem => restrictedItem.list_item_id === listItem.list_item_id
      );
    }


    const beforeCloseForItemFunc = ()=>{
        reapplyCoupon();
        recalculateTax();
        getShippingRates();
        reloadOrderInfo();
    }

     const couponItems = computed(() => {
        return props.couponItems;
    });

    const afterDelete = computed(() => {
        return route("shop.show");
    });
</script>
